import type { Pass } from '@/types';
import type { CreatePassRequest, UpdatePassRequest } from '@/shared/api';
import { normalizeDateToEnd, normalizeDateToStart } from '@/shared/lib/calendarDate';

export const passDraftToCreateRequest = (draft: Omit<Pass, 'id'>): CreatePassRequest => ({
  name: draft.name,
  startsAt: normalizeDateToStart(draft.startsAt),
  endsAt: draft.endsAt === null ? null : normalizeDateToEnd(draft.endsAt),
  maxCredits: draft.credits?.maxCredits ?? null,
});

export const passDraftToUpdateRequest = (draft: Omit<Pass, 'id'>): UpdatePassRequest => ({
  name: draft.name,
  startsAt: normalizeDateToStart(draft.startsAt),
  endsAt: draft.endsAt === null ? null : normalizeDateToEnd(draft.endsAt),
  credits: draft.credits,
});
